export const byCount = (a: { count: number }, b: { count: number }) => {
  return b.count - a.count
}

export const onlyN = (n: number) => (elm: any, index: number) => index < n
